var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Navbar',{attrs:{"data-aos":"flip-down"}}),_c('Banner',{attrs:{"data-aos":"flip-up"}}),_c('Content'),_c('Footer',{attrs:{"data-aos":"flip-up"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }